var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIcnEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 5.5C1.25 4.80964 1.80964 4.25 2.5 4.25H21.5C22.1904 4.25 22.75 4.80965 22.75 5.5V18.5C22.75 19.1904 22.1904 19.75 21.5 19.75H2.5C1.80964 19.75 1.25 19.1904 1.25 18.5V5.5ZM2.75 17.1034V6.56047L8.39801 11.0789L2.75 17.1034ZM3.73117 18.25H20.2688L14.4271 12.0188L12.4685 13.5857C12.1946 13.8048 11.8054 13.8048 11.5315 13.5857L9.57292 12.0188L3.73117 18.25ZM15.602 11.0789L21.25 17.1034V6.56047L15.602 11.0789ZM12 12.0395L4.13809 5.75H19.8619L12 12.0395Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEmail);
export default __webpack_public_path__ + "static/media/icn-email.42e035d2f79285cc90812d1588192de2.svg";
export { ForwardRef as ReactComponent };